/* eslint quote-props: "off" */
import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import CenterLoadingSpinner from '../../components/LoadingSpinner/CenterLoadingSpinner';
import { useUserContext } from '../../contexts/UserContext';

const EAM_URL = "https://eam.whitedog.cloud";

const StrevEmbed: React.FC = () => {
  const auth = useAuth();
  const userContext = useUserContext();
  const [appReady, setAppReady] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [authData, setAuthData] = useState<any>(null);
  const [ssoWindow, setSsoWindow] = useState<Window | null>(null);
  const iframeRef = useRef<HTMLIFrameElement | null>(null);

  const handleMessage = (event: MessageEvent<any>): void => {
    console.log("EAM:::Message", event);

    if (event.data?.type === "SSO_LOGIN_SUCCESS") {
      setAuthenticated(true);
      ssoWindow?.close();
    }

    if (event.data?.type === "AUTH_SUCCESS") {
      const { response, payload } = event.data;

      // set response in your local state to avoid this call again.
      iframeRef.current?.contentWindow?.postMessage(
        {
          type: "SSO_LOGIN_RESPONSE",
          loginResponse: response,
        },
        EAM_URL
      );
    }
  };

  const onIframeLoad = () => {
    const w = window.open(
      "https://authbackend.eam.whitedog.cloud/auth/login/?provider=wdc",
      "_blank",
      "width=500,height=650,left=450,top=100",
    );

    setSsoWindow(w);
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (auth.user == null) {
    return <CenterLoadingSpinner />;
  }

  return <iframe src={EAM_URL} ref={iframeRef} onLoad={onIframeLoad} className='w-screen lg:w-[calc(100vw-64px)] -h-screen-nav' />;
};

export default StrevEmbed;
